import { Chip } from "@mui/material";
import { Button, Icon } from "@platform/design-system";

interface NeedsReviewCommentsToolbarButtonProps {
  count: number;
  disabled: boolean;
  onClick: () => void;
}

/**
 * The `COMMENTS` button in the Present toolbar, with its comment-count badge.
 * Split out of `PresentWrapper` to keep the badge's conditional rendering out
 * of that component's own complexity budget.
 */
const NeedsReviewCommentsToolbarButton = ({
  count,
  disabled,
  onClick,
}: NeedsReviewCommentsToolbarButtonProps): React.JSX.Element => (
  <Button
    variant="tertiary"
    size="sm"
    onClick={onClick}
    disabled={disabled}
    startIcon={<Icon name="comment" />}
    sx={{ flexShrink: 0 }}
    data-testid="needs-review-comments-toolbar-button"
  >
    Comments
    {count > 0 && (
      <Chip
        label={count}
        size="small"
        color="brandPrimary"
        sx={{ ml: 1, minWidth: 25, fontSize: "0.7rem", borderRadius: 1 }}
      />
    )}
  </Button>
);

export default NeedsReviewCommentsToolbarButton;
